<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.base_setting')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main-content">
        <div @click="triggerFileInput()" class="item van-hairline--bottom">
          <div class="left">{{$t("setting.avatar")}}</div>
          <div class="right">
            <img  :src="this.userInfo.header_img || '/img/avatar.png'" style="width: 47px;height: 47px;" onerror="this.src='/img/error.png'">
          </div>
        </div>
        <input type="file" ref="fileInput" accept="image/*" style="display:none" @change="onFileChange">
        <div class="item van-hairline--bottom" @click="toSetName()">

        <div class="left">{{$t("setting.real_name")}}</div>
        <div class="right">
          <span class="desc">{{this.userInfo.name ? this.userInfo.name : this.$t("setting.no_setting")}}</span>
          <van-icon name="arrow" />
        </div>
      </div>
        <div class="item van-hairline--bottom" @click="toSetSex()">
        <div class="left">{{$t("setting.sex")}}</div>
        <div class="right">
          <span class="desc">{{this.userInfo.sex !== "0" ? this.userInfo.sex === "1" ? this.$t("setting.man") :this.$t("setting.female"): this.$t("setting.unkown")}}</span>
          <van-icon name="arrow" />
        </div>
      </div>
        <div class="item van-hairline--bottom" @click="toSetBank()">
        <div class="left">{{$t("setting.bind_bank_info")}}</div>
        <div class="right">
          <span class="desc">{{this.isBank ? this.$t("setting.bindinged") :this.$t("setting.no")}}</span>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { instance } from '../../http/index';
import api from '../../http/api';
import { Base64 } from 'js-base64';
export default {
  data() {
    return {
      isBank:false,
      userInfo:{},
      uploading:false
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    triggerFileInput(){
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.click();
    },
    onFileChange(e){
      const file = e.target.files[0];
      if(!file) return;
      const formData = new FormData();
      formData.append('file', file);
      this.uploading = true;
      instance.post(api['upload_avatar'], formData).then(res => {
        this.uploading = false;
        const body = res.data || {};
        if(body.code === 200){
          const url = JSON.parse(Base64.decode(body.data));
          this.$http({
            method: 'post',
            data:{header_img: url},
            url: 'user_header_img'
          }).then(res2=>{
            if(res2.code === 200){
              this.getUserInfo();
              this.$toast(res2.msg);
            }else if(res2.code === 401){
              this.$toast(res2.msg);
            }
          });
        } else {
          this.$toast('上传失败');
        }
      }).catch(() => {
        this.uploading = false;
        this.$toast('上传失败');
      });
    },
    toSetName(){
      this.$router.push({path:'/Setname'});
    },
    toSetBank(){
      this.$router.push({path:'/Setbank'});
    },
    toSetSex(){
      this.$router.push({path:'/Setsex'});
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.isBank = true;
          }else {
            this.isBank = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container .main-content {
  padding: 0 20px;
  background-color: #fff;
}
.container .main-content .item{
  padding: 30px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 30px;
}
.container .main-content .item .right{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.container .main-content .item .right img{
  width: 90px;
}
.container .main-content .van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.container .main-content .item .right .desc-cell-number, .container .main-content .item .right .desc{
  font-size: 30px;
  font-weight: 700;
  color: #979799;
}
</style>
